import { FormControl, FormHelperText, IconButton, Input, InputAdornment, InputLabel, LinearProgress } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './Login2.css';
import background from "../assets/Images/login_bg_1.png";
import Logo from "../assets/Images/image_2024_06_18T11_03_16_909Z.png"
import { useAuth } from "../APP/Context/AuthContext";
import { Lock, Person, VerifiedUser } from "@mui/icons-material";



const Login: React.FC = () => {

    let navigate = useNavigate();
    const [progress, setProgress] = React.useState(0);
    const [loadProgress, setLoadProgress] = React.useState(false);
    const { login } = useAuth();



    const [inputs, setInputs] = useState<any>({});
    // const [showPassword, setShowPassword] = React.useState(false);
    //const handleClickShowPassword = () => setShowPassword((show) => !show);
    // const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     event.preventDefault();
    // };
    const [error, setError] = useState({
        userName: '',
        password: ''
    });
    React.useEffect(() => {
        if (loadProgress) {
            setProgress(70);
        }
        else {
            setProgress(0);
        }
    }, [loadProgress]);


    const submitLogin = (event: React.FormEvent<HTMLFormElement>) => {
        // debugger
        event.preventDefault();
        setLoadProgress(true);
        // console.log(inputs);


        if (!inputs.userName) {
            setError((prevErrors) => ({ ...prevErrors, userName: "Please enter Username" }));
        }
        if (!inputs.password) {
            setError((prevErrors) => ({ ...prevErrors, password: "Please enter Password" }));
        }
        if (inputs.userName !== undefined && inputs.password !== undefined) {
            if (error.userName === '' && error.password === "") {
                try {
                    login(inputs).then(user => {
                        // console.log('user.status', user);
                        if (user) {
                            setInputs({});
                            navigate("/ClientMaster");
                        }
                        setProgress(100);
                        setLoadProgress(false);

                    });
                }
                catch (ex) {

                    console.log("Error : ", ex);

                }

            }
        }




    };

    const handelSubmit = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        // console.log(name + ":" + value);
        setInputs((values: any) => ({ ...values, [name]: value }))
        setError((prevError) => ({ ...prevError, [name]: "" }));
    };

    const handleFocus = (fieldName: any) => {

        if (!inputs[fieldName]) {
            setError((prevErrors) => ({ ...prevErrors, [fieldName]: "Please enter " + fieldName }));
        }
    };

    return (<>
        <div
            style={{ display: `${loadProgress ? '' : 'none'}` }}
        ><LinearProgress variant="determinate" value={progress} /></div>


        {/* <div className="login_main">
            <div className="login_card">
                <div className="login_1">
                    <img src={Logo} className="login_img" alt="logo" ></img>
                </div>
                <div className="login_2">
                    <div className="login_header">
                        <h3>SIGN IN</h3>
                    </div>
                    <form onSubmit={submitLogin}>
                        <div className="login_content">


                            <FormControl sx={{ width: '85%' }} variant="standard">
                                <InputLabel sx={{ fontSize: 12 }} htmlFor="standard-adornment-password">Username</InputLabel>
                                <Input
                                    id="standard-adornment-password"
                                    type="text"
                                    name="userName"
                                    onFocus={() => handleFocus('userName')}

                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton sx={{ color: '#243C5C' }}
                                                aria-label="toggle password visibility" tabIndex={-1}>
                                                <Person />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onChange={handelSubmit}
                                    error={!!error.userName}


                                />
                                {error.userName ? <FormHelperText sx={{ color: 'red', fontSize: 10 }}>{error.userName}</FormHelperText> : <FormHelperText sx={{ color: 'white', fontSize: 10 }}>username</FormHelperText>}

                            </FormControl>

                            <FormControl sx={{ width: '85%' }} variant="standard">
                                <InputLabel sx={{ fontSize: 12 }} htmlFor="standard-adornment-password">Password</InputLabel>
                                <Input
                                    id="standard-adornment-password"
                                    type="password"
                                    //type={showPassword ? 'text' : 'password'}
                                    onChange={handelSubmit}
                                    name="password"
                                    onFocus={() => handleFocus('password')}
                                    error={!!error.password}
                                    sx={{
                                        "input::-ms-reveal,input::-ms-clear": {
                                            "display": "none"
                                        }
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                sx={{ color: '#243C5C' }}
                                                tabIndex={-1}
                                            // onClick={handleClickShowPassword}
                                            //onMouseDown={handleMouseDownPassword}
                                            >
                                                <Lock />
                                            </IconButton>
                                        </InputAdornment>
                                    }

                                />
                                {error.password ? <FormHelperText sx={{ color: 'red', fontSize: 10 }}>{error.password}</FormHelperText> : <FormHelperText sx={{ color: 'white', fontSize: 10 }}>username</FormHelperText>}
                            </FormControl>
                            <div>
                                <button className="login_btn" type="submit" onClick={() => submitLogin}><span><VerifiedUser /> &nbsp; SIGN IN</span></button>

                            </div>
                            

                        </div>
                    </form>

                </div>
            </div>
        </div> */}
        <div className="main_login_body">
            <div className="signin">
                {/* <div className="login_1">
                    <img src={Logo} className="login_img" alt="logo" ></img>
                </div> */}

                <form className="form" onSubmit={submitLogin}>

                    <div className="login_1">
                        <img src={Logo} className="login_img" alt="logo" ></img>
                    </div>
                    <div className="flex-column">
                        <label>UserName </label>
                    </div>
                    <div className="inputForm">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 32 32" height="20">
                            <g data-name="Layer 3" id="Layer_3">
                                <path
                                    d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z">
                                </path>
                            </g>
                        </svg>
                        <input placeholder="Enter your UserName" name="userName" onChange={handelSubmit} className="input" type="text" required />
                    </div>

                    <div className="flex-column">
                        <label>Password </label>
                    </div>
                    <div className="inputForm">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="-64 0 512 512" height="20">
                            <path
                                d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0">
                            </path>
                            <path
                                d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0">
                            </path>
                        </svg>
                        <input placeholder="Enter your Password" className="input" name="password" onChange={handelSubmit} type="password" required />
                    </div>
                    {error.password ? <FormHelperText sx={{ color: 'red', fontSize: 10 }}>{error.password}</FormHelperText> : <FormHelperText sx={{ color: 'white', fontSize: 10 }}></FormHelperText>}

                    <div className="flex-row">
                        <div>
                            {/* <input type="radio" />
              <label>Remember me </label> */}
                        </div>
                        <span className="span">Forgot password?</span>
                    </div>
                    <button className="button-submit" type="submit">Sign In</button>
                    {/* <p className="p">Don't have an account? <span className="span">Sign Up</span>

                    </p> */}
                </form>
            </div>
        </div>
    </>);
}


export default Login;